import { config } from '../env'


export const getUserProfileURL = () => {
    return config('ACCOUNTS_DOMAIN') + '/user/profile'
}
export const getUserRegistrationPage = () => {
    return config('ACCOUNTS_DOMAIN') + '/register?redirect_back=' + window.location.origin + '/verified'
}
export const getAccountDomain = () => {
    return config('ACCOUNTS_DOMAIN')
}
export const getApiEndpoint = () => {
    return config('API_ENDPOINT')
}